export default __webpack_public_path__ + "static/media/installation-video-android-DA.fca5c3c8.mp4";